export default __webpack_public_path__ + "static/Poppins-SemiBoldItalic-3524ffc3226f4578e5c52840ddcec068.ttf";